import { css, styled } from 'styles';

export const inputStyle = css`
  background-color: ${({ theme }) => theme.input.background};
  border: thin solid ${({ theme }) => theme.input.border};
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.input.color};
  display: inline-block;
  font-family: Inter, sans-serif;
  height: ${({ theme }) => theme.element.height}px;
  line-height: ${({ theme }) => theme.element.lineHeight};
  outline: none;
  padding: 0 ${({ theme }) => theme.spacing.relative.smaller};
  transition: border-color ${({ theme }) => theme.transition.medium} ease-in-out,
    box-shadow ${({ theme }) => theme.transition.medium} ease-in-out;

  &:disabled {
    opacity: 0.5;
  }

  &:focus {
    border-color: ${({ theme }) => theme.input.focus.border};
    box-shadow: ${({ theme }) => theme.shadow.highlight};

    &::placeholder {
      opacity: 0.5;
    }
  }

  &::placeholder {
    color: ${({ theme }) => theme.input.placeholder.color};
    transition: opacity ${({ theme }) => theme.transition.medium} ease-in-out;
  }
`;

export const StyledInput = styled.input.attrs({
  'data-lpignore': true,
})`
  ${inputStyle};
`;

StyledInput.displayName = 'Input';
